// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import VatSummaryModel from '../../model/vat-summary-model';
import VatSummaryDTO from '../dto/vat-summary-dto';
import dtoSchema from '../schemas/vat-summary-schema';

export default abstract class VatSummaryModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<VatSummaryDTO>) {
    super();
    if (data) {
      this.vatRate = data.vatRate;
      this.vatAmount = data.vatAmount;
      this.netAmount = data.netAmount;
    }
  }
  /**
  * @type {double}
  */
  vatRate?: number;
  /**
  * @type {double}
  */
  vatAmount?: number;
  /**
  * @type {double}
  */
  netAmount?: number;

  static toModel(dto: DeepPartial<VatSummaryDTO>): VatSummaryModel;
  static toModel(dto: DeepPartial<VatSummaryDTO> | undefined | null): VatSummaryModel | undefined;
  static toModel(dto: DeepPartial<VatSummaryDTO> | undefined | null): VatSummaryModel | undefined {
    return dto ? new VatSummaryModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<VatSummaryModel> | VatSummaryModel): VatSummaryDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      vatRate: unwrapped.vatRate,
      vatAmount: unwrapped.vatAmount,
      netAmount: unwrapped.netAmount,
    } as VatSummaryDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for VatSummaryModel, can not map to VatSummaryDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
